import { Result, ok, TrackingDetails } from '../../../tracking-api';
import { Scorm2004Api } from '../api';
import { LocalScorm2004Api, LocalScorm2004Repository } from '../local';
import { Scorm2004ApiResolver } from './scorm2004-api-resolver';

export class LocalScorm2004ApiResolver implements Scorm2004ApiResolver {

  constructor(private repository: LocalScorm2004Repository) {
  }

  public resolve(details: TrackingDetails): Result<Scorm2004Api, false> {
    this.repository.initialize(details);
    return ok(new LocalScorm2004Api(this.repository));
  }
}
